module.exports = __webpack_public_path__ + "img/gww_04.69e3ec0a.jpg";